/**
 * Enumeration and properties pertaining to prebuilt bet cards.
 *
 * @class PrebuiltCardTypes
 * @name types
 * @memberof Mojito.Modules.PrebuiltBets
 */

export default class PrebuiltCardTypes {}

/**
 * Enumerator representing possible market types for a prebuilt card.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.PrebuiltBets.types
 */
PrebuiltCardTypes.MARKETS = {
    PREBUILT_ACCA: 'PBAC',
    PREBUILT_BET_BUILDER: 'PBBB',
    PREBUILT_BET_BUILDER_BOOSTED: 'PBMK',
    PREBUILT_BET_BUILDER_FIXED: 'PBMF',
};
